import { render, staticRenderFns } from "./TipoIncidencias.vue?vue&type=template&id=1d5eb7bd&scoped=true"
import script from "./TipoIncidencias.vue?vue&type=script&lang=js"
export * from "./TipoIncidencias.vue?vue&type=script&lang=js"
import style0 from "./TipoIncidencias.vue?vue&type=style&index=0&id=1d5eb7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5eb7bd",
  null
  
)

export default component.exports